export const SOCIAL_STATUS = {
  ONLINE: "online",
  OFFLINE: "offline",
} as const;

export type SocialStatus = (typeof SOCIAL_STATUS)[keyof typeof SOCIAL_STATUS];
